import { render, staticRenderFns } from "./SaleDetails.vue?vue&type=template&id=8bb5db48&scoped=true&"
import script from "./SaleDetails.vue?vue&type=script&lang=js&"
export * from "./SaleDetails.vue?vue&type=script&lang=js&"
import style0 from "./SaleDetails.vue?vue&type=style&index=0&id=8bb5db48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb5db48",
  null
  
)

export default component.exports